import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../matomo';

/**
 * Vues de page sur navigation interne.
 *
 * Le Tag Manager Matomo Cloud s'en chargeait tout seul ; le tracker classique
 * de l'instance auto-hébergée, non. Sans ce composant, seule la page d'entrée
 * serait comptée — un site en apparence suivi, mais dont toute la navigation
 * est invisible.
 */
export default function MatomoPageViews() {
  const { pathname, search } = useLocation();
  // La première vue est déjà dans la file de `initMatomo()` : sans ce garde-fou
  // la page d'entrée serait comptée deux fois.
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    trackPageView();
  }, [pathname, search]);

  return null;
}
